import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["multiLine"],
    _excluded2 = ["multiLine"];
import { TextInputField } from '@flowio/react-text-input';
import { TextAreaField } from '@flowio/react-text-area';
import React, { useEffect } from 'react';
import warning from 'warning';
var didWarnDeprecation = false;

var TextField = function TextField(props) {
  useEffect(function () {
    if (!didWarnDeprecation) {
      didWarnDeprecation = true;
      process.env.NODE_ENV !== "production" ? warning(false, 'The TextField component is deprecated. For multi-line text fields ' + 'use `TextAreaField` from `@flowio/react-text-area. For single-line ' + 'text fields use `TextInputField` from `@flowio/react-text-input`.') : void 0;
    }
  }, []); // TypeScript cannot deduce the type of `unhandledProps` when the object is
  // destructured, because the variables would not be related at that point.
  // eslint-disable-next-line react/destructuring-assignment

  if (props.multiLine) {
    // `multiLine` is not a known property in `TextAreaField`.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _multiLine = props.multiLine,
        _unhandledProps = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/React.createElement(TextAreaField, _unhandledProps);
  } // `multiLine` is not a known property in `TextAreaField`.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var multiLine = props.multiLine,
      unhandledProps = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(TextInputField, unhandledProps);
};

TextField.displayName = 'TextField';
export default TextField;